import { InjectionToken } from '@angular/core';

// A simple description of the token
const TOKEN_DESCRIPTION = 'Global window object';

// An options object that configures the behavior of the token
const TOKEN_BEHAVIOR = {
  factory: () => window, // indicates that the token will return the globalwindow object when injected into an Angular artifact
};

export const WINDOW = new InjectionToken<Window>(
  TOKEN_DESCRIPTION,
  TOKEN_BEHAVIOR
);
